export default __webpack_public_path__ + "static/media/13.98c1759a.png";